<!-- @format -->

<ng-container *transloco="let t">
  <fudis-heading [level]="3" [variant]="'md'">{{ module().name | localizedString }}</fudis-heading>
  @if (timingTemplateOptions$ | async; as templates) {
    @if (templates?.length) {
      <fudis-select
        [control]="templateSelectControl"
        [label]="t('TIMELINE.TIMING_TEMPLATE.TIMING_TEMPLATE')"
        [placeholder]="t('TIMELINE.TIMING_TEMPLATE.SELECT')"
        (selectionUpdate)="emitSelectedTemplate($event)">
        <ng-template fudisSelectOptions>
          @for (option of templates; track option.value.id) {
            <fudis-select-option [data]="option" />
          }
        </ng-template>
      </fudis-select>
    } @else {
      <fudis-body-text [variant]="'md-light'" class="fudis-text-emptystate">{{ t("TIMELINE.TIMING_TEMPLATE.NOT_IN_USE") }}</fudis-body-text>
    }
  }
</ng-container>
